import './blogDetails.scss'
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {GetBlogById, SendFeedback,} from "../../../redux/actions";
import {connect} from "react-redux";
import React, {useEffect, useState} from "react";
import {generateFileMediaUrl} from "../../../utils/generateMediaUrl";
import {Link, useHistory, useParams} from "react-router-dom";
import moment from "moment/moment";
import {FacebookIcon, InstagramIcon, TwitterIcon} from "../../../assets/images";
import Blogs from "../../homepage/blog/Blog";
import {FacebookShareButton, LinkedinShareButton, TwitterShareButton} from "react-share";
import {_hostMedia} from "../../../redux/api";


function BlogDetail(props) {
    const {blogById, staticTexts, selectedLanguage} = props
    const params = useParams();
    const [opinion, setOpinion] = useState({
        like: false,
        dislike: false,
    })
    const [feedback, setFeedback] = useState(false)
    const shareUrl = `${_hostMedia}/blogs/${params?.slug}`
    const history   = useHistory();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        props.GetBlogById(params?.slug);
    }, [params?.slug, selectedLanguage?.id])


    function sendFeedback(name, value) {
        const opinionData = {
            ...opinion,
            [name]: value
        }
        props.SendFeedback(blogById?.id, opinionData).then(() => {
            setFeedback(true)
        })
    }

    return <div className={'blogDetail_wrapper'}>
        <div className={'blogDetail_header'}>
            <span onClick={() => history.goBack()} className={'back_link'}>{staticTexts?.blog_detail_link_text}</span> <span>/ {blogById?.title}</span>
        </div>
        <div className={'blogDetail_content'}>
            <div className={'blogDetail_content_img'}>
                <img src={generateFileMediaUrl(blogById?.mediaMain?.path)}
                     className="blogDetail_image"
                     title={blogById?.mediaMain?.title ? blogById?.mediaMain?.title : ''}
                     alt={blogById?.mediaMain?.altAttribute ? blogById?.mediaMain?.altAttribute : ''}/>
                <div className={'blogDetail_socials'}>
                    <TwitterShareButton url={shareUrl} title={'Twitter'}>
                        <TwitterIcon/>
                    </TwitterShareButton>
                    <FacebookShareButton url={shareUrl} title={"Facebook"}>
                        <FacebookIcon/>
                    </FacebookShareButton>
                    <LinkedinShareButton url={shareUrl} title={"Linkedin"}>
                        <InstagramIcon/>
                    </LinkedinShareButton>
                </div>
                <div className={'blogDetail_data'}>
                    {staticTexts?.blog_detail_data_text} <span>{moment(blogById?.data).format('MMMM DD')}</span>
                </div>
            </div>
            <div className={'blogDetail_content_info'}>
                <div className={'blogDetail_category'}>
                    {
                        blogById?.categories?.map(category => {
                            return <span>#{category?.title}</span>
                        })
                    }
                </div>
                <div className={'blogDetail_title'}>
                    {blogById?.title}
                </div>
                <div className={'blogDetail_subtitle'}>
                    {blogById?.subtitle}
                </div>
                <img src={generateFileMediaUrl(blogById?.mediaMain?.path)}
                     className="blogDetail_mobile_image"
                     title={blogById?.mediaMain?.title ? blogById?.mediaMain?.title : ''}
                     alt={blogById?.mediaMain?.altAttribute ? blogById?.mediaMain?.altAttribute : ''}/>
                <div className={'blogDetail_description'} dangerouslySetInnerHTML={{__html: blogById?.description}}/>
                <div className={'blogDetail_mobile_content'}>
                    <div className={'blogDetail_data'}>
                        {staticTexts?.blog_detail_data_text} <span>{moment(blogById?.data).format('MMMM DD')}</span>
                    </div>
                    <div className={'blogDetail_socials'}>
                        <TwitterShareButton url={shareUrl} title={'Twitter'}>
                            <TwitterIcon/>
                        </TwitterShareButton>
                        <FacebookShareButton url={shareUrl} title={"Facebook"}>
                            <FacebookIcon/>
                        </FacebookShareButton>
                        <LinkedinShareButton url={shareUrl} title={"Linkedin"}>
                            <InstagramIcon/>
                        </LinkedinShareButton>
                    </div>
                </div>
                {
                    !feedback ? <div className={'blogDetail_btn_block'}>
                        <div className={'blogDetail_btn_title'}>
                            {staticTexts?.blog_detail_btn_title}
                        </div>
                        <div className={'blogDetail_btn_content'}>
                        <span className={'blogDetail_btn'} onClick={() => sendFeedback('like', true)}>
                            👍 {staticTexts?.blog_detail_btn_yes_text}
                        </span>
                            <span className={'blogDetail_btn'} onClick={() => sendFeedback('dislike', true)}>
                            👎 {staticTexts?.blog_detail_btn_no_text}
                        </span>
                        </div>
                    </div> : <div className={'blogDetail_btn_block'}>
                        <div className={'blogDetail_btn_title'}>
                            {staticTexts?.blog_detail_opinion_title}
                        </div>
                        <div className={'blogDetail_btn_content'}>
                            🎉 {staticTexts?.blog_detail_opinion_text}
                        </div>
                    </div>
                }
            </div>
        </div>
        <Blogs isDetail={true}/>
    </div>
}

const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'blogById',
    'selectedLanguage'
]);

const mapDispatchToProps = {
    GetBlogById,
    SendFeedback
};

export default connect(mapStateToProps, mapDispatchToProps)(BlogDetail);